import React , {Component} from 'react';
import {
    Page  , Link
} from 'framework7-react';

import { connect } from "react-redux";
import {
    toolbar
} from "../actions";

class LoginSingUp extends Component{
    componentDidMount(){
        if (localStorage.getItem('logged') !== undefined && localStorage.getItem('logged') !== null )
        {
            this.$f7router.navigate('/')
            return false
        }



    }



    onPageBeforeIn(){
        this.props.toolbar(false)
    }


    render(){
        return(
            <Page name="LoginSingUp"  className="bg-white" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>
                <div id="inner-header" >

                    <Link back id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        ورود / ثبت نام
                    </div>
                </div>

                <div id="login-singup">
                    <div className="b-container">
                        <div className="b-row">
                            <div className="b-col">
                                <div className="text-center ">
                                    <img className="img" src="https://www.lavefood.com/webappassets/images/logo.svg"/>
                                    {/*<h1 className="title">نارنج</h1>*/}
                                    <h5 className="sub-title">سفارش آنلاین غذا</h5>
                                    <p className="description">
                                        برای ادامه نیاز به ورود یا عضویت دارید.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="b-row no-gutters">
                            <div className="b-col-6 pl-1">
                                <Link href="/login/" className="btn-custom-3" id="login">
                                    ورود
                                </Link>
                            </div>
                            <div className="b-col-6 pr-1">
                                <Link href="/signup/" className="btn-custom-3" id="sing-up">
                                    ثبت نام
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

               

            </Page>

        )
    }
}

const mapDispatchToProps = dispatch => ({

    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps  , mapDispatchToProps)(LoginSingUp);
